import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, BehaviorSubject  } from 'rxjs';

export interface Locale {
	lang: string;
	data: Object;
}

@Injectable({
	providedIn: 'root'
})
export class TranslationService {
	private langIds: any = [];
	private selectedLang: string;
	public observableLang: BehaviorSubject <string>;
	constructor(private translate: TranslateService) {
		// add new langIds to the list
		this.translate.addLangs(['tr']);

		// this language will be used as a fallback when a translation isn't found in the current language
		this.translate.setDefaultLang('tr');
		this.observableLang = new BehaviorSubject<string>(this.selectedLang);
	}

	public loadTranslations(...args: Locale[]): void {
		const locales = [...args];

		locales.forEach(locale => {
			// use setTranslation() with the third argument set to true
			// to append translations instead of replacing them
			this.translate.setTranslation(locale.lang, locale.data, true);

			this.langIds.push(locale.lang);
		});

		// add new languages to the list
		this.translate.addLangs(this.langIds);
	}

	setLanguage(lang) {
		if (lang) {
			this.translate.use(lang);
			localStorage.setItem('language', lang);
			this.selectedLang = lang;
			this.observableLang.next(this.selectedLang);
		}
	}

	public getSelectedLanguage(): Observable<any> {
		return of(localStorage.getItem('language') || this.translate.getDefaultLang());
	}
}
